import { ApiError } from './Reject';
import axios from 'axios';
import { toast } from 'react-toastify';

export function handleApiError(error: unknown): ApiError {
    let apiError: ApiError = { message: 'An unexpected error occurred.' };

    if (axios.isAxiosError(error)) {
        if (error.response?.status === 429) {
            const message = 'Too many attempts. Please wait a few minutes and try again.';
            toast.error(message, { toastId: 'rate-limit', autoClose: 6000 });
            return { message };
        }
        if (error.response && error.response.data) {
            apiError = error.response.data as ApiError;
        } else if (error.message) {
            apiError = { message: error.message };
        }
    }
    else if (error instanceof Error) {
        apiError = { message: error.message };
    }

    return apiError;
}
